<template>
  <summary-section
    v-if="userAwards.length > 0"
    heading="Awards & Certifications"
  >
    <template v-slot:actions>
      <router-link
        :to="linkHref"
        class="summary-section__action-link"
      >
        View All
      </router-link>
    </template>
    <div class="awards-summary">
      <loading-spinner v-if="loading !== 0" />
      <awards-list
        v-else
        :awards="userAwards"
        :limit="3"
      />
    </div>
  </summary-section>
</template>

<script>
import SummarySection from '@/components/User/Summary/SummarySection.vue';
import AwardsList from '@/components/User/AwardsList.vue';
import { USER_AWARDS_QUERY } from '@/graphql/queries/user-queries';

export default {
  name: 'AwardsSummary',
  components: {
    SummarySection,
    AwardsList,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    limit: {
      type: Number,
      default: 0,
    },
    linkHref: {
      type: String,
      default: '/profile/awards',
    },
  },
  data() {
    return {
      loading: 0,
      userAwards: [],
    };
  },
  apollo: {
    userAwards: {
      query: USER_AWARDS_QUERY,
      variables() {
        return {
          userId: this.user.id,
        };
      },
    },
  },
};
</script>
